const languages = [
  { name: 'Português', uuid: 'POR' },
  { name: 'Inglês', uuid: 'ENG' },
  { name: 'Espanhol', uuid: 'SPA' },
  { name: 'Francês', uuid: 'FRA' },
  { name: 'Alemão', uuid: 'DEU' },
  { name: 'Amárico', uuid: 'AMH' },
  { name: 'Árabe', uuid: 'ARA' },
  { name: 'Bengali', uuid: 'BEN' },
  { name: 'Canares', uuid: 'KAN' },
  { name: 'Chinês', uuid: 'ZHO' },
  { name: 'Coreano', uuid: 'KOR' },
  { name: 'Dinamarquês', uuid: 'DAN' },
  { name: 'Estoniano', uuid: 'EST' },
  { name: 'Finlandês', uuid: 'FIN' },
  { name: 'Grego', uuid: 'ELL' },
  { name: 'Hebraico', uuid: 'HEB' },
  { name: 'Hindi', uuid: 'HIN' },
  { name: 'Holandês', uuid: 'NLD' },
  { name: 'Húngaro', uuid: 'HUN' },
  { name: 'Indonésio', uuid: 'IND' },
  { name: 'Italiano', uuid: 'ITA' },
  { name: 'Iorubá', uuid: 'YOR' },
  { name: 'Japonês', uuid: 'JPN' },
  { name: 'Javanês', uuid: 'JAV' },
  { name: 'Maori', uuid: 'MRI' },
  { name: 'Mongol', uuid: 'MON' },
  { name: 'Norueguês', uuid: 'NOR' },
  { name: 'Persa', uuid: 'FAS' },
  { name: 'Polonês', uuid: 'POL' },
  { name: 'Russo', uuid: 'RUS' },
  { name: 'Sueco', uuid: 'SWE' },
  { name: 'Suaíli', uuid: 'SWA' },
  { name: 'Tagalo', uuid: 'TGL' },
  { name: 'Tâmil', uuid: 'TAM' },
  { name: 'Telugo', uuid: 'TEL' },
  { name: 'Tibetano', uuid: 'BOD' },
  { name: 'Turco', uuid: 'TUR' },
  { name: 'Ucraniano', uuid: 'UKR' },
  { name: 'Urdu', uuid: 'URD' },
  { name: 'Vietnamita', uuid: 'VIE' },
  { name: 'Zulu', uuid: 'ZUL' },
];

const languagesCollection = [...languages];

const languagesWithDescription = [
  ...languages,
  {
    name: 'Português [Áudio descrição]',
    uuid: 'PAD',
  },
];

const removeAccents = str => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const defaultLanguageWithLabels = async (inputValue = '') => {
  if (!inputValue) {
    return {
      options: languages.map(language => ({
        label: language.name,
        value: language.uuid,
      })),
      hasMore: false,
    };
  }
  return {
    options: languages
      .filter(language =>
        removeAccents(language.name.toLowerCase()).startsWith(
          removeAccents(inputValue.toLowerCase())
        )
      )
      .map(language => ({
        label: language.name,
        value: language.uuid,
      })),
    hasMore: false,
  };
};

export const collectionLanguageWithLabels = () => ({
  options: languagesCollection.map(language => ({
    label: language.name,
    value: language.uuid,
  })),
  hasMore: false,
});

export const defaultLanguageWithDescriptionLabels = () => ({
  options: languagesWithDescription.map(language => ({
    label: language.name,
    value: language.uuid,
  })),
  hasMore: false,
});

export default languages;
